import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/shared/point-arrow-iconv2.svg")